/**
 * src/shell/hooks/usePluginExtensionSlots.ts
 *
 * Reactive React hook for subscribing to dynamic plugin extension slot updates
 * (sidebar navigation items, header actions, chat attachments, cards, and workspace views).
 */

import { useState, useEffect } from 'react';
import { globalHotPluginManager, type PluginExtensionSlot } from '../../plugins/sdk/hot-plugin-manager.js';

export interface PluginExtensionSlots {
  sidebar: Array<{ pluginId: string; slot: PluginExtensionSlot }>;
  header: Array<{ pluginId: string; slot: PluginExtensionSlot }>;
  chatAttachment: Array<{ pluginId: string; slot: PluginExtensionSlot }>;
  chatCard: Array<{ pluginId: string; slot: PluginExtensionSlot }>;
  workspaceView: Array<{ pluginId: string; slot: PluginExtensionSlot }>;
}

export function usePluginExtensionSlots(): PluginExtensionSlots {
  const [slots, setSlots] = useState<PluginExtensionSlots>(globalHotPluginManager.getAllSlots());

  useEffect(() => {
    const handleUpdate = () => {
      setSlots(globalHotPluginManager.getAllSlots());
    };

    globalHotPluginManager.on('slots:updated', handleUpdate);
    globalHotPluginManager.on('plugin:installed', handleUpdate);
    globalHotPluginManager.on('plugin:uninstalled', handleUpdate);

    return () => {
      globalHotPluginManager.off('slots:updated', handleUpdate);
      globalHotPluginManager.off('plugin:installed', handleUpdate);
      globalHotPluginManager.off('plugin:uninstalled', handleUpdate);
    };
  }, []);

  return slots;
}
